import React, { useState } from 'react';
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { PaymentDashboardItem } from '../../models/referralModel';

interface Props {
  isOpen: boolean;
  toggle: () => void;
  item: PaymentDashboardItem | null;
  onConfirm: (referralId: string, paymentReference: string) => Promise<void>;
  isLoading: boolean;
}

const formatCurrency = (amount?: number | null) => {
  if (amount === undefined || amount === null) return '$0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

const MarkPaidModal: React.FC<Props> = ({
  isOpen,
  toggle,
  item,
  onConfirm,
  isLoading,
}) => {
  const [reference, setReference] = useState('');

  if (!item) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onConfirm(item.id, reference);
    setReference('');
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} className="border-0 pb-0">
        <h4 className="font-weight-bold mb-0 text-dark">Marcar como Pagado</h4>
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody className="py-3">
          <p className="text-muted" style={{ fontSize: '13px' }}>
            Estás a punto de confirmar el pago de la recompensa para{' '}
            <strong className="text-dark">{item.referrer.name}</strong> por un monto de{' '}
            <strong className="text-success font-weight-bold">
              {formatCurrency(item.reward_amount)}
            </strong>
            .
          </p>

          <FormGroup className="mb-0">
            <Label style={{ fontSize: '12px', fontWeight: 600 }}>
              Número de comprobante o referencia (opcional)
            </Label>
            <Input
              type="text"
              placeholder="Ej. REF-8392019"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              style={{ fontSize: '13px', borderRadius: '6px' }}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter className="border-0 pt-0">
          <Button
            color="secondary"
            outline
            size="sm"
            onClick={toggle}
            disabled={isLoading}
            style={{ borderRadius: '6px', padding: '6px 16px' }}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            size="sm"
            disabled={isLoading}
            style={{
              borderRadius: '6px',
              padding: '6px 18px',
              backgroundColor: '#00c389',
              borderColor: '#00c389',
              color: '#ffffff',
              fontWeight: 600,
            }}
          >
            {isLoading ? 'Procesando...' : 'Confirmar pago'}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default MarkPaidModal;
